
import { Component } from '@angular/core';
import { fadeInOut } from '../../services/animations';
import { ApiService } from '../../services/api.service';
import { Product } from '../../models/product.model';
import { Benefit } from '../../models/benefit.model';
import { MatDialog } from '@angular/material';
import { CreateEditBenefitModalComponent } from './create-edit-benefit-modal/create-edit-benefit-modal.component';
import { Vendor } from '../../models/vendor.model';
import { DialogType, AlertService } from '../../services/alert.service';
import { ActivatedRoute } from '@angular/router';
import { AccountService } from '../../services/account.service';
import { PermissionValues, Permission } from '../../models/permission.model';
import { Angular5Csv } from '../../../../node_modules/angular5-csv/dist/Angular5-csv';
import * as _ from 'lodash';
import * as moment from 'moment';

@Component({
    selector: 'benefits',
    template: require('./benefits.component.html'),
    styles: [require('./benefits.component.css')],
    animations: [fadeInOut]
})
export class BenefitsComponent {
    benefits: Benefit[];
    benefitsPriceTotal: number = 0;
    benefitsCostTotal: number = 0;
    vendors: Vendor[];
    productId: number;
    product: Product;
    vendorId: number;
    parentsLink = [];
    writeBenefitsPermission = Permission.writeBenefitsPermission;
    constructor(private route: ActivatedRoute, private apiService: ApiService, public dialog: MatDialog, private alertService: AlertService, public accountService: AccountService) {
        this.route.params.subscribe(params => {
            this.productId = params['productId'];
            this.vendorId = params['vendorId'];
            this.getBenefits();
        });
        this.getVendors();
    }

    getBenefits() {

        if (this.productId) {

            this.apiService.getProductById(this.productId).subscribe(r => {
                this.product = r;
                this.parentsLink = [{ name: 'Plans', link: 'products' }, { name: this.product.productName + ' (' + this.product.productId + ')'}];
            })
            this.apiService.getBenefitsByProductId(this.productId).subscribe(r => {
                this.benefits = r;
                this.caclBenefitsPriceAndCost();
            })
        } else if (this.vendorId) {
            this.parentsLink = [{ name: 'Vendors(' + this.vendorId + ')', link: 'vendors' }];
            this.apiService.getBenefitsByVendorId(this.vendorId).subscribe(r => {
                this.benefits = r;
                this.caclBenefitsPriceAndCost();
            })
        } else {
            this.apiService.getBenefits().subscribe(r => {
                this.benefits = r;
                this.caclBenefitsPriceAndCost();
            })
        }
    }

    getVendors() {
        this.apiService.getVendors().subscribe(r => {
            this.vendors = r;
        });
    }

    caclBenefitsPriceAndCost() {
        _.each(this.benefits, b => {
            this.benefitsPriceTotal += b.price;
            this.benefitsCostTotal += b.cost;
        })
        this.benefitsPriceTotal = parseFloat(this.benefitsPriceTotal.toFixed(2));
        this.benefitsCostTotal = parseFloat(this.benefitsCostTotal.toFixed(2));
    }

    createEditBenefit(benefit: any) {
        let dialogRef = this.dialog.open(CreateEditBenefitModalComponent, {
            panelClass:"col-md-6",
            data: {
                currentBenefit: benefit,
                vendors: this.vendors,
                productId: this.productId
            }
        });

        dialogRef.afterClosed().subscribe(r => {
            this.getVendors();
            this.getBenefits();
        })
    }

    deleteBenefit(benefitId: number) {
        this.alertService.showDialog("Do you want to delete this Benefit ?", DialogType.confirm, val => {

            this.apiService.deleteBenefit(benefitId).subscribe(r => {
                this.getBenefits();
            });
        });
    }

    downloadCsv() {
        var csv = new Angular5Csv(_.map(this.benefits, g => {
            return { 'benefitId': g.benefitId, 'vendorId': g.vendorId, 'benefitCode': g.benefitCode, 'benefitName': g.benefitName, 
                'benefitTypeId': g.benefitTypeId, 'price': g.price, 'cost': g.cost}; }),
            'LA_Benefit_csv_' + moment().format('YYYY-MM-DD'),
            {
                'showLabels': true, headers: ["Benefit Id", "Vendor Id", "Benefit Code", "Benefit Name", "Benefit Type Id", "Price", "Cost"],
            });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/benefits/benefits.component.ts